import { KeyboardEvent } from 'react';

export const isEnterKey = (e: KeyboardEvent<HTMLElement>): boolean => e.key === 'Enter'

export const onEnterAction = (e: KeyboardEvent<HTMLElement>, action: () => void|Promise<void>): void => {
  if (e.key === 'Enter') {
    action();
  }
}

export const onEscapeAction = (e: KeyboardEvent<HTMLElement>, action: () => void|Promise<void>): void => {
  if (e.key === 'Escape') {
    action();
  }
}
